import React from "react";

import { Icons } from "../ui/icons";
import { Input } from "../ui/input";

const SearchInput = ({ searchTerm, onSearchChange, placeholder = "Search items...", className = "" }) => {
	return (
		<div className={`flex-1 max-w-md relative ${className}`}>
			<div className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none">
				<Icons.Search className="h-4 w-4" />
			</div>
			<Input
				type="text"
				placeholder={placeholder}
				value={searchTerm}
				onChange={(e) => onSearchChange(e.target.value)}
				className="h-9 bg-gray-50/50 border-0 ring-0 focus:ring-0 pl-10"
			/>
		</div>
	);
};

export default SearchInput;
